import * as React from "react";
import { useOrgQuery } from "../../../../hooks/queries/useOrgQuery";
import * as Styled from "../styles.css";
import { Header, Section } from "../../../../components/layout";
import { TableCell, TableRow, Link } from "../../../../components/util";
import { Button, Spinner, Stack, Typography } from "@safetyculture/sc-web-ui";
import { OrgUserModal } from "./OrgUserModal";
import { UserAccountStatusBadge } from "../../../users/UserAccountStatusBadge";

type Props = { orgId: string };

export const OrgUsersTab: React.FC<Props> = ({ orgId }) => {
  const { isLoading, data: org, refetch } = useOrgQuery(orgId);

  const [is_org_user_modal_open, setOrgUserModalOpen] = React.useState(false);

  if (isLoading) {
    return (
      <Stack
        spacing="s6"
        align="center"
        direction="column"
        justify="center"
        minHeight={"250px"}
      >
        <Spinner />
      </Stack>
    );
  }

  return (
    <>
      {!org?.users || org?.users?.length === 0 ? (
        <Stack
          spacing="s6"
          align="center"
          direction="column"
          justify="center"
          minHeight={"250px"}
        >
          <Typography variant="bodyMedium" color="surface.text.weak">
            There are no users for this organisation
          </Typography>
          <Button variant="secondary" onClick={() => setOrgUserModalOpen(true)}>
            Add existing user
          </Button>
        </Stack>
      ) : (
        <Styled.Grid>
          <Section>
            <Header
              title="Users"
              type="section"
              titleIcon="people"
              actions={
                <Button
                  variant="secondary"
                  onClick={() => setOrgUserModalOpen(true)}
                >
                  Add existing user
                </Button>
              }
            />
            <Styled.Table
              columns={[
                { title: "User name", expand: true },
                { title: "User email", expand: true },
                { title: "Role", expand: true },
                { title: "Status", expand: true },
              ]}
            >
              {org?.users?.map(
                user =>
                  !!user && (
                    <TableRow key={user?.id}>
                      <TableCell>
                        <Link
                          href={`/users/${
                            user?.id
                          }?backText=${encodeURIComponent(org.name)}`}
                        >
                          {user.firstname} {user.lastname}
                        </Link>
                      </TableCell>
                      <TableCell>
                        <Typography variant="inherit" clamp={1}>
                          {user.email}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          variant="inherit"
                          style={{ textTransform: "capitalize" }}
                        >
                          {user?.roles[0]}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <UserAccountStatusBadge status={user.account_status} />
                      </TableCell>
                    </TableRow>
                  ),
              )}
            </Styled.Table>
          </Section>
        </Styled.Grid>
      )}
      {is_org_user_modal_open && org && (
        <OrgUserModal
          org_data={org}
          onClose={() => setOrgUserModalOpen(false)}
          onConfirm={() => {
            refetch();
          }}
        />
      )}
    </>
  );
};
